import type { FunctionComponent, PropsWithChildren } from "react"

import { Heading } from "@jobteaser/spark/components/Heading"
import { Paper } from "@jobteaser/ui-kit/components/Paper/Paper"

import styles from "./CardLayout.module.css"

type CardLayoutProps = PropsWithChildren<{
  title: string
}>

export const CardLayout: FunctionComponent<CardLayoutProps> = props => {
  const { children, title } = props

  return (
    <Paper radius="radius" smallSpacing className={styles.main}>
      <Heading variant="title3" weight="bold" as="h3" className={styles.title}>
        {title}
      </Heading>
      <div>{children}</div>
    </Paper>
  )
}
